export default "__VITE_ASSET__Qid4qwcS__"